import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
/*
  Generated class for the PaisProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CongresosProvider {

  //private api: string = "http://192.168.1.161/ionic3/micongreso/api/";
  private api: string;
  private usuario;
  public congreso;
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
    this.congreso = window.localStorage["congreso"];
    // this.usuario = this.global.usuario;
  }

  public all(): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token
    };
    /* alert(this.global.guid);
     alert(this.global.usuario);
     alert(this.global.token);*/
    console.log(parametros);
    return this.http.post(this.api + "congresos/lista.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }
  public alldispositivo(): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "token": this.global.token
    };
    /* alert(this.global.guid);
     alert(this.global.usuario);
     alert(this.global.token);*/
    console.log(parametros);
    return this.http.post(this.api + "congresos/listadispositivo.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public elimina_congreso_dispositivo(congreso): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "clavecongreso": congreso,
      "token": this.global.token
    };
    /* alert(this.global.guid);
     alert(this.global.usuario);
     alert(this.global.token);*/
    console.log(parametros);
    return this.http.post(this.api + "congresos/elimina_congreso_dispositivo.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }

  public size_congreso(clavecongreso): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "clavecongreso": clavecongreso,
      "token": this.global.token
    };
    /* alert(this.global.guid);
     alert(this.global.usuario);
     alert(this.global.token);*/

    return this.http.post(this.api + "congresos/size_congreso.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public allbusca(): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token
    };
    //  alert(this.global.guid);
    console.log('<--proximo-->');
    console.log(parametros);
    return this.http.post(this.api + "congresos/lista_busca.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public allapps(pagina): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "pagina": pagina
    };
  
    return this.http.post(this.api + "congresos/lista_apps.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public numero_apps(): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
  
    let parametros ={
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "pagina": 0
    };
    console.log(parametros);
    
     return this.http.post(this.api+"congresos/numero_apps.php", parametros, options).map(
      (response) => {
        console.log(response);
        var respuesta = response.json();
        
        return respuesta[0];
      }
    ).catch(this.handleError);
  }
  
  public buscaapps(cadena): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token,
      "cadena": cadena
    };
    //  alert(this.global.guid);
    console.log('<--proximo-->');
    console.log(parametros);
    return this.http.post(this.api + "congresos/busca_apps.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public allbuscaanteriores(): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token
    };
    //  alert(this.global.guid);
    console.log('<--anteriores-->');
    console.log(parametros);
    return this.http.post(this.api + "congresos/lista_busca_anteriores.php", parametros, options).map(
      (response) => {

        return response.json();

      }
    ).catch(this.handleError);
  }
  public devuelvecongreso(clavecongreso): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clave": clavecongreso
    };
    console.log(parametros);
    return this.http.post(this.api + "congresos/congresoclave.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];

      }
    ).catch(this.handleError);

    /*let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "campofiltro": "clave",
      "valorfiltro": clavecongreso
    };
    console.log("<!---------------------------->");
    console.log(parametros);
    console.log("<!---------------------------->");
    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);*/
  }
  public devuelvedispositivo(): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "dispositivos",
      "campofiltro": "guid",
      "valorfiltro": this.global.guid
    };
    console.log(parametros);
    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public devuelveversion(): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "aplicaciones",
      "campofiltro": "clave",
      "valorfiltro": this.global.cod_aplicacion
    };
    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        return response.json();

      }
    ).catch(this.handleError);
  }
  public devuelvecongresonombre(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "nombre": clavecongreso
    };
    console.log(parametros);
    return this.http.post(this.api + "congresos/congresonombre.php", parametros, options).map(
      (response) => {
        console.log(response);
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Guarda congreso seleccionado
  public congresoseleccionado(congreso): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    if (this.global.esbackoffice == true) {
      let parametros = {
        "clave": this.global.ficha_usuario['clave'],
        "clavecongreso": congreso.clave,
        "token": this.global.token
      };


      return this.http.post(this.api + "congresos/seleccionacongreso.php", parametros, options).map(
        (response) => {


          return response.json();
        }
      ).catch(this.handleError);
    } else {
      let parametros = {
        "guid": this.global.guid,
        "clavecongreso": congreso.clave,
        "token": this.global.token
      };
      /*  alert(this.global.guid);
        alert(congreso.clave);
        alert(this.global.token);*/
      return this.http.post(this.api + "congresos/seleccionacongresodispositivo.php", parametros, options).map(
        (response) => {

          window.localStorage["congreso"] = response.json();
          return response.json();
        }
      ).catch(this.handleError);
    }


  }
  public congresodispositivo(): Observable<any> {
    //this.usuario.clave
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "dispositivo": this.global.guid,
      "claveusuario": this.global.usuario,
      "token": this.global.token
    };
    // alert("busca congreso para este guid"+this.global.guid);

    return this.http.post(this.api + "congresos/congresodispositivo.php", parametros, options).map(
      (response) => {
        //    alert('popo');




        return response.json();

      }
    ).catch(this.handleError);
  }


  // Registra un dispositivo
  public registrodispositivo(dispositivo): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "dispositivo": this.global.guid,
      "token": this.global.token,
      "prueba": this.global.esprueba
    };


    return this.http.post(this.api + "congresos/registrodispositivo.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }

  public registroidnotificacion(dispositivo, idnotificacion, tipo, clavecongreso, cod_aplicacion): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "dispositivo": this.global.guid,
      "idnotificacion": idnotificacion,
      "tipo": tipo,
      "clavecongresos": clavecongreso,
      "claveapp": cod_aplicacion,
      "token": this.global.token
    };



    return this.http.post(this.api + "congresos/registroidnotificacion.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }

  // Registro de un dispositivo en un congreso
  public altacongreso(nombre, password): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "dispositivo": this.global.guid,
      "nombre": nombre,
      "password": password,
      "token": this.global.token
    };

    return this.http.post(this.api + "congresos/altacongreso.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }
  public altacongresoclave(clave): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "dispositivo": this.global.guid,
      "clave": clave,
      "token": this.global.token
    };

    console.log(parametros);
    console.log(this.api + "congresos/altacongreso_clave.php");
    return this.http.post(this.api + "congresos/altacongreso_clave.php", parametros, options).map(
      (response) => {

        window.localStorage["congreso"] = response.json();
        return response.json();
      }
    ).catch(this.handleError);
  }
  // Elimina un congreso
  public delete(ncongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "clave": ncongreso,
    };

    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    congreso.claveusuario = this.global.usuario;
    congreso.tema = "light";
    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "parametros": congreso
    };

    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }


  // Inserta un congreso nuevo
  public compruebaindentificador(nombre): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "identificador": nombre
    };

    return this.http.post(this.api + "congresos/idcongreso.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso, imgicono, imgcabecera, imgpresentacion, imgcartel): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "clave": congreso.clave,
      "parametros": congreso,
      "imgicono": imgicono,
      "imgcabecera": imgcabecera,
      "imgpresentacion": imgpresentacion,
      "imgcartel": imgcartel
    };


    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }
  public insert_congreso(congreso): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    congreso.claveusuario = this.global.usuario;
    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "parametros": congreso
    };

    return this.http.post(this.api + "congresos/inserta_congreso.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }
  public update_congreso(congreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "clave": congreso.clave,
      "parametros": congreso
    };

    return this.http.post(this.api + "congresos/edita_congreso.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }
  // Inserta un congreso nuevo
  public update_presentacion(congreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "congresos",
      "clave": congreso.clave,
      "parametros": congreso
    };
    return this.http.post(this.api + "congresos/edita_estilo.php", parametros, options).map(
      (response) => {
        console.log(response);
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public compruebalicenciatemp(congreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "clave": congreso.clave
    };

    return this.http.post(this.api + "congresos/licencia_temp.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }
  public compruebalicencia(congreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "clave": congreso.clave
    };

    return this.http.post(this.api + "congresos/licencia.php", parametros, options).map(
      (response) => {

        return response.json();
      }
    ).catch(this.handleError);
  }


  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
  public updateusuario(usuario): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "usuarios",
      "clave": usuario.clave,
      "parametros": usuario
    };
    console.log(parametros);

    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/providers/congresos/congresos.ts